"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _PatientScanViewerDto = _interopRequireDefault(require("../model/PatientScanViewerDto"));

var _PatientScanViewerMetadataDto = _interopRequireDefault(require("../model/PatientScanViewerMetadataDto"));

var _PatientScanViewerMetadataDtoPaginatedList = _interopRequireDefault(require("../model/PatientScanViewerMetadataDtoPaginatedList"));

var _ProvisioningStatusDto = _interopRequireDefault(require("../model/ProvisioningStatusDto"));

var _StatusMessageDto = _interopRequireDefault(require("../model/StatusMessageDto"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* PatientScanViewerProvisioning service.
* @module 2/PatientScanViewerProvisioningApi
* @version 5.0.2
*/
var PatientScanViewerProvisioningApi = /*#__PURE__*/function () {
  /**
  * Constructs a new PatientScanViewerProvisioningApi. 
  * @alias module:2/PatientScanViewerProvisioningApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function PatientScanViewerProvisioningApi(apiClient) {
    _classCallCheck(this, PatientScanViewerProvisioningApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Discards the patient scan viewer. (Requires: Roles -> RH.PS.Delete).
   * @param {String} id The identifier.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  _createClass(PatientScanViewerProvisioningApi, [{
    key: "patientscansIdViewerDeleteWithHttpInfo",
    value: function patientscansIdViewerDeleteWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientscansIdViewerDelete");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = null;
      return this.apiClient.callApi('/patientscans/{id}/viewer', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Discards the patient scan viewer. (Requires: Roles -> RH.PS.Delete).
     * @param {String} id The identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "patientscansIdViewerDelete",
    value: function patientscansIdViewerDelete(id) {
      return this.patientscansIdViewerDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Make a patient scan available for viewing and provide a link where it is available on the Dicom viewer. (Requires: Roles -> RH.PS.Create).
     * @param {String} id The patient scan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientScanViewerDto} and HTTP response
     */

  }, {
    key: "patientscansIdViewerGetWithHttpInfo",
    value: function patientscansIdViewerGetWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientscansIdViewerGet");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _PatientScanViewerDto["default"];
      return this.apiClient.callApi('/patientscans/{id}/viewer', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Make a patient scan available for viewing and provide a link where it is available on the Dicom viewer. (Requires: Roles -> RH.PS.Create).
     * @param {String} id The patient scan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientScanViewerDto}
     */

  }, {
    key: "patientscansIdViewerGet",
    value: function patientscansIdViewerGet(id) {
      return this.patientscansIdViewerGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get specific patient's scan viewer metadata. (Requires: Roles -> RH.PS.Read).
     * @param {String} id The patient scan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientScanViewerMetadataDto} and HTTP response
     */

  }, {
    key: "patientscansIdViewermetadataGetWithHttpInfo",
    value: function patientscansIdViewermetadataGetWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientscansIdViewermetadataGet");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _PatientScanViewerMetadataDto["default"];
      return this.apiClient.callApi('/patientscans/{id}/viewermetadata', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get specific patient's scan viewer metadata. (Requires: Roles -> RH.PS.Read).
     * @param {String} id The patient scan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientScanViewerMetadataDto}
     */

  }, {
    key: "patientscansIdViewermetadataGet",
    value: function patientscansIdViewermetadataGet(id) {
      return this.patientscansIdViewermetadataGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get all patient scan viewer metadata. (Requires: Roles -> RH.PS.Read).
     * @param {Object} opts Optional parameters
     * @param {module:model/ProvisioningStatusDto} opts.provisioningStatus Filter for a provisioning status of interest.
     * @param {String} opts.studyInstanceUid Filter for a Dicom Study Instance UID (0020,000D) of interest.
     * @param {Array.<String>} opts.patientScanIds The patient scan ids.
     * @param {String} opts.dateTimeFrom Filter the start date when patient scans got provisioned.
     * @param {String} opts.dateTimeTo Filter the end date when patient scans got provisioned.
     * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
     * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned. (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientScanViewerMetadataDtoPaginatedList} and HTTP response
     */

  }, {
    key: "patientscansViewermetadataGetWithHttpInfo",
    value: function patientscansViewermetadataGetWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'provisioningStatus': opts['provisioningStatus'],
        'studyInstanceUid': opts['studyInstanceUid'],
        'patientScanIds': this.apiClient.buildCollectionParam(opts['patientScanIds'], 'multi'),
        'dateTimeFrom': opts['dateTimeFrom'],
        'dateTimeTo': opts['dateTimeTo'],
        'pageIndex': opts['pageIndex'],
        'pageSize': opts['pageSize']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _PatientScanViewerMetadataDtoPaginatedList["default"];
      return this.apiClient.callApi('/patientscans/viewermetadata', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get all patient scan viewer metadata. (Requires: Roles -> RH.PS.Read).
     * @param {Object} opts Optional parameters
     * @param {module:model/ProvisioningStatusDto} opts.provisioningStatus Filter for a provisioning status of interest.
     * @param {String} opts.studyInstanceUid Filter for a Dicom Study Instance UID (0020,000D) of interest.
     * @param {Array.<String>} opts.patientScanIds The patient scan ids.
     * @param {String} opts.dateTimeFrom Filter the start date when patient scans got provisioned.
     * @param {String} opts.dateTimeTo Filter the end date when patient scans got provisioned.
     * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
     * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned. (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientScanViewerMetadataDtoPaginatedList}
     */

  }, {
    key: "patientscansViewermetadataGet",
    value: function patientscansViewermetadataGet(opts) {
      return this.patientscansViewermetadataGetWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return PatientScanViewerProvisioningApi;
}();

exports["default"] = PatientScanViewerProvisioningApi;